import type { HTMLAttributes, ReactNode } from 'react';
import { Icon } from '../Icon';
import styles from './Alert.module.css';

export interface AlertProps extends Omit<HTMLAttributes<HTMLDivElement>, 'role'> {
  /** Visual variant that determines background and accent colors */
  variant?: 'error' | 'success' | 'info' | 'warning';
  /** Icon element to display (typically from Icon component) */
  icon?: ReactNode;
  /** Alert message/content */
  children: ReactNode;
  /** Optional callback when close button is clicked */
  onClose?: () => void;
}

export function Alert({
  variant = 'info',
  icon,
  children,
  onClose,
  className,
  ...props
}: AlertProps) {
  const classes = [styles.alert, styles[variant], className].filter(Boolean).join(' ');

  return (
    <div className={classes} role="alert" aria-live="polite" {...props}>
      {icon && <span className={styles.iconWrapper}>{icon}</span>}
      <span className={styles.content}>{children}</span>
      {onClose && (
        <button
          type="button"
          className={styles.closeButton}
          onClick={onClose}
          aria-label="Cerrar alerta"
        >
          <Icon name="close" size="sm" className={styles.closeIcon} />
        </button>
      )}
    </div>
  );
}

Alert.displayName = 'Alert';

